import React, { useState, useEffect } from "react";
// import logo from "../../public/assets/images/Logo.jpg";
// import logo from "../assets/images/Logo.jpg";
import man from "../assets/images/user/1.jpg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosConfig from "../services/axiosConfig";
import { Login, LOGIN, Password, RememberMe } from "../constant";
import { useNavigate, Link } from "react-router-dom";
import styled from "styled-components";

const Signin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loginIn, setLoginIn] = useState(false);
  const navigate = useNavigate();

  // Load saved credentials if rememberMe was previously selected
  useEffect(() => {
    const savedUsername = localStorage.getItem("savedUsername");
    const savedPassword = localStorage.getItem("savedPassword");
    const remember = localStorage.getItem("rememberMe") === "true";

    if (remember) {
      setUsername(savedUsername || "");
      setPassword(savedPassword || "");
      setRememberMe(true);
    }
  }, []);

  const loginAuth = async () => {
    setLoginIn(true);

    if (username !== "" && password !== "") {
      const formData = { username, password };

      axiosConfig
        .post("login", formData)
        .then((res) => {
          if (!res.data.error) {
            // Save credentials if RememberMe is checked
            if (rememberMe) {
              localStorage.setItem("savedUsername", username);
              localStorage.setItem("savedPassword", password);
              localStorage.setItem("rememberMe", true);
            } else {
              localStorage.removeItem("savedUsername");
              localStorage.removeItem("savedPassword");
              localStorage.removeItem("rememberMe");
            }

            const token = {
              token: res.data.data.token,
              role: res.data.data.role,
              username: res.data.data.username,
            };

            localStorage.setItem("token", JSON.stringify(token));
            localStorage.setItem("role", res.data.data.role);
            localStorage.setItem("username", res.data.data.username);
            localStorage.setItem("userId", res.data.data.userId);
            localStorage.setItem("login", true);
            navigate(`/dashboard`);
          } else {
            toast.error("Invalid Username or Password !");
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setLoginIn(false);
        });
    } else {
      toast.warn("Enter Username and Password !");
      setLoginIn(false);
    }
  };

  return (
    <Wrapper>
      <div className="page-wrapper">
        <div className="container-fluid p-0">
          <div className="authentication-main">
            <div className="row">
              <div className="col-md-12">
                <div className="auth-innerright">
                  <div className="authentication-box">
                    <div className="text-center">
                      <img src='/assets/images/Logo.jpg' alt="" style={{width:'100px'}} />
                    </div>
                    <div className="card mt-4">
                      <div className="card-body">
                        <div className="text-center">
                          <h4>{LOGIN}</h4>
                          <h6>{"Enter your Username and Password"} </h6>
                        </div>
                        <form className="theme-form">
                          <div className="form-group">
                            <label className="col-form-label pt-0">Username</label>
                            <input
                              className="form-control"
                              type="text"
                              name="username"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                              placeholder="Username"
                            />
                          </div>
                          <div className="form-group">
                            <label className="col-form-label">{Password}</label>
                            <input
                              className="form-control"
                              type="password"
                              name="password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                          </div>
                          <div className="checkbox p-0">
                            <input
                              id="checkbox1"
                              type="checkbox"
                              checked={rememberMe}
                              onChange={(e) => setRememberMe(e.target.checked)}
                            />
                            <label htmlFor="checkbox1">{RememberMe}</label>
                          </div>
                          <div className="form-group form-row mt-3 mb-0 d-grid">
                            <button
                              className="btn btn-primary"
                              type="button"
                              onClick={() => loginAuth()}
                              disabled={ loginIn}
                            >
                              {loginIn ? "Logging in..." : Login}
                            </button>
                          </div>
                          <Link
                            to={`${process.env.PUBLIC_URL}/pages/forgetPwd`}
                            className="forgot-pwd"
                            style={{marginTop:'1rem'}}
                          >
                            Forgot Password?
                          </Link>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer />
        </div>
      </div>
    </Wrapper>
  );
};

export default Signin;

const Wrapper = styled.div`
  .forgot-pwd {
    display: flex;
    justify-content: center;
  }
`;
